import HorizontalSeparator from '@sdk/components/ui/HorizontalSeparator';
import { ThemeColorType } from '@sdk/theme/ThemeColorType';

import {
  SectionMarker,
  ShortSeparatorContainer,
} from '@web/timesheets/CreateTimesheetModal/components/ShortSeparator/shortSeparator.styles';

const ShortSeparator = () => (
  <SectionMarker justifyContent="flex-end">
    <ShortSeparatorContainer>
      <HorizontalSeparator themeColor={ThemeColorType.separatorOnGray} />
    </ShortSeparatorContainer>
  </SectionMarker>
);

export default ShortSeparator;
